import { Modal, Row, Col, Typography } from 'antd';
import { AnotacionesModel } from '../../../models/UserTask';
import './Anotaciones.less';
/**
 * @component Anotaciones.tsx
 * @description Anotaciones component show notes of the inpectors.
 * @return { Component }
 */

 interface AnotacionesProps{
    notas: AnotacionesModel | undefined
    closeModalNotas: ()=>void;
 }

function Anotaciones(props: AnotacionesProps) {
  const { Text } = Typography;

  const handleCancel = () => {
    props.closeModalNotas()
  };
  
  const TitleCustom = () =>{
    return(
        <div className={'title-custom-notas'}>
           {`Notas: ${props?.notas?.inspector} | ${props?.notas?.nombreTarea}`}
        </div>
    )
  }

  return (
    <div>
      <Row>
        <Col span={24}>
          <Modal
            title={<TitleCustom/>}
            visible={true}
            onCancel={handleCancel}
            width={520}
            centered={true}
            className={'org-task__modal'}
            maskClosable={false}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
          >
            <Text style={{whiteSpace: 'pre-wrap'}}>
                {props?.notas?.notas}
            </Text>
          </Modal>
        </Col>
      </Row>
    </div>
  );
}

export default Anotaciones;
